module.exports = [{
  plugin: require('/opt/build/repo/gatsby-browser.js'),
  options: {
    "plugins": []
  }
}];